export default __webpack_public_path__ + "static/media/Privacy_Policy_eSthenos.8c3fdce5.pdf";